export class AppUtil {
    static cardAspectRatio: number = 730 / 1040;

}